import { Divider, FormControl, RadioGroup,
  Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { values } from '@weft/utils';
import VyDialog from 'apps/app/src/components/new-design/feedback/VyDialog';
import React, { useState } from 'react';
import type { PlanCreateReason } from '../../../../../contexts/create-plan-context/create-plan-context-types/plan-create-reason';
import { PLAN_CREATION_REASONS } from '../../../../../contexts/create-plan-context/create-plan-context-types/plan-create-reason';
import { useDialog } from '../../../../../hooks/use-dialog';
import { useVyNavigate } from '../../../../../hooks/use-vy-navigate';
import { MenuItemPlanCreationReasonOption } from './MenuItemPlanCreationReasonOption';

type MenuItemRevisionProps = {
  contractId: string;
  disabled?: boolean;
};

export const MenuItemReviseContract: React.FC<MenuItemRevisionProps> = ({ contractId, disabled }) => {
  const navigate = useVyNavigate();
  const { isDialogOpen, handleOpen, handleClose } = useDialog();

  const [planCreateReason, setPlanCreateReason] = useState<PlanCreateReason>(PLAN_CREATION_REASONS.ReviseContractForRenewal);

  const handleDialogSubmit = () => {
    navigate(`/plans/contracts/${contractId}/revise?planCreateReason=${planCreateReason}`);
    handleClose();
  };

  const handlePlanCreationReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (values<string>(PLAN_CREATION_REASONS).includes(event.target.value)) {
      setPlanCreateReason(event.target.value as PlanCreateReason);
    }
  };

  return (
    <div onClick={e => e.stopPropagation()}>
      <MenuItem
        className='pb-2'
        disabled={disabled}
        onClick={handleOpen}
      >
        <Typography>Revise</Typography>
      </MenuItem>
      <VyDialog 
        open={isDialogOpen}
        onClose={handleClose}
        label="Contract Revision"
        cancelButtonText="Cancel"
        ctaText="Continue"
        onSubmit={handleDialogSubmit}
      >
        <FormControl>
          <RadioGroup
            value={planCreateReason}
            onChange={handlePlanCreationReasonChange}
          >
            <MenuItemPlanCreationReasonOption
              value={PLAN_CREATION_REASONS.ReviseContractForRenewal}
              title="Contract renewal with new terms"
              description="Update products, prices, and general terms. The revised contract will go into effect upon the renewal date."
            />
            
            <Divider className="my-5" />

            <MenuItemPlanCreationReasonOption
              value={PLAN_CREATION_REASONS.ReviseCurrentContract}
              title="Update current contract terms"
              description="Add new products or promotions to the current contract. The initial contract start date and duration will remain the same, updated terms will apply on future invoices."
            />
          </RadioGroup>
        </FormControl>
      </VyDialog>
    </div>
  );
};